import { LanguageConstants } from 'src/app/constants/language-constants';
import { CountryConstants } from './../../constants/country-constants';
import { ClientStateEnums } from '../../enum/client-state-enums';
import { TypePersonEnums } from 'src/app/enum/type-person-enums';

export class ClientModel {
  clientId: number = 0;
  typeDocumentId: number = 0;
  document: string = "";
  digitVerification: number = 0;
  document2: string | null = null;
  digitVerification2: number | null = null;
  typePersonId: number = TypePersonEnums.juridica;
  names: string | null = null;
  lastNames: string | null = null;
  businessName: string = "";
  businessName2: string | null = null;
  comercialName: string | null = null;
  address: string = "";
  email: string | null = null;
  taxEmail: string | null = null;
  phone: string = "";
  alterPhone: string | null = null;
  departmentId: number = 0;
  cityId: number = 0;
  observation: string | null = null;
  swExpirationDays: boolean = false;
  expirationDays: number = 0;
  stateChangeDate: Date = new Date();
  clientStateId: number = ClientStateEnums.activo;
  postalCode: string | null = null;
  ciiuCode: string | null = null;
  swIvaRetainer: boolean = false;
  swIvaResponsible: boolean = false;
  swDeclarant: boolean = false;
  swGreatContributor: boolean = false;
  swSimpleTaxRegime: boolean = false;
  ratePromptPayment: number = 0;
  kgQuota: number = 0;
  countryCode: string = CountryConstants.colombia;
  languageCode: string = LanguageConstants.español;
  currencyId: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
